module.exports = __webpack_public_path__ + "img/40_38_027_300.c3e77186.jpg";